export enum ModeEnum {
    DARK = "dark",
    LIGHT = "light"
}
